import { useCallback, useEffect, useState } from 'react'

import useCreateListing from '~/hooks/useCreateListing'

export type StepState = {
  step: number
  completed: number
  subStep: number
  subject_id?: string
  isListingForm?: boolean
  stepTitles: string[]
}

const initialState = { step: 0, completed: 0, subStep: 0 }

const useWizardState = ({ store, setStore, isListingForm, stepTitles }) => {
  const [state, setState] = useState<StepState>({ ...initialState, stepTitles })

  useEffect(() => {
    window.scrollTo({ top: 0 })
  }, [state])

  const { onDraftListing } = useCreateListing({
    store,
    setStore,
    formStep: state?.step,
    stepTitles
  })

  const setStep = useCallback((step: number): void => {
    setState((state) => ({ ...state, step }))
  }, [])

  const onNext = (step: number): void => {
    const nextStep = step + 1

    if (isListingForm) {
      onDraftListing(nextStep)
    }

    setState((state) => ({
      ...state,
      step: nextStep,
      completed: nextStep,
      subStep: 0
    }))
  }

  const onBack = useCallback(
    (step: number): void =>
      setState((state) => ({ ...state, step: step - 1, subStep: 9999 })),
    []
  )

  const setSubStep = useCallback(
    (subStep): void => setState((state) => ({ ...state, subStep })),
    []
  )
  const onDraft = () => onDraftListing()

  return {
    state,
    setStep,
    setSubStep,
    onNext,
    onBack,
    setState,
    onDraft,
    isListingForm
  }
}

export default useWizardState
